import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationStart } from '@angular/router';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { SearchComponentDef } from '@df/search/search.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfUiModule } from '@df/ui/df-ui.module';
import { TranslationModule } from '@df/ui/translation/translation.module';

@Component({
    selector: 'search',
    templateUrl: './search.html',
    styleUrls: ['./search.scss'],
    standalone: true,
    imports: [DfUiModule, FormsModule, TranslationModule, SizeClassDirective]
})
export class SearchComponent extends SearchComponentDef implements OnInit {
    @Output()
    closed = new EventEmitter<boolean>();
    /**
     * Icon when form is visible
     */
    @ViewChild('inputBoxOn', { read: ElementRef })
    private inputBoxOnRef?: ElementRef<HTMLElement>;
    /**
     * Icon when form is not visible
     */
    @ViewChild('inputBoxOff', { read: ElementRef })
    private inputBoxOffRef?: ElementRef<HTMLElement>;
    /**
     * Currently set animation shift
     */
    private animationShift = 0;

    private elementRef = inject(ElementRef);

    override ngOnInit() {
        super.ngOnInit();
        (this.searchService as KlevuSearchService).loadKlevuVars(() => this.detectChanges());
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
        this.subscriptions.add(
            this.app.events.on('close-search-tray').subscribe(() => {
                if (this.isFocus) {
                    this.close();
                }
            })
        );
        this.subscriptions.add(
            this.meta.routerEvents.subscribe(event => {
                if (event instanceof NavigationStart) {
                    this.reset();
                }
            })
        );
    }
    keyup(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.code === 'Enter') {
            this.input?.nativeElement.blur();
            this.goToSearch();
            this.close();
        }
    }
    close(): void {
        this.toggleVisibility(false);
        this.app.events.broadcast('search.close');
        this.closed.emit(true);
        this.detectChanges();
        this.reset();
    }
    /**
     * To show opening/closing animation we need to know distance between the form (visible on focus) and the icon (visible on blur).
     */
    private updateAnimationShift() {
        if (!!this.inputBoxOffRef || !!this.inputBoxOnRef) {
            const animationShift =
                (this.isFocus ? this.animationShift : 0) +
                (this.inputBoxOffRef?.nativeElement.getBoundingClientRect().right || 0) -
                (this.inputBoxOnRef?.nativeElement.getBoundingClientRect().right || 0);
            this.animationShift = animationShift;
            this.elementRef.nativeElement.style.setProperty('--animation-shift', `${animationShift}px`);
        }
    }
    toggleVisibility(to: boolean) {
        this.isFocus = to;
        if (this.app.client.isX || this.app.client.isL) {
            this.updateAnimationShift();
        }
        this.timeoutService.setTimeout(() => {
            if (to) {
                this.renderer2.addClass(this.elementRef.nativeElement, '_is-focused');
            } else {
                this.renderer2.removeClass(this.elementRef.nativeElement, '_is-focused');
            }
        }, 500);
    }

    get termModel() {
        return this.term;
    }

    set termModel(value: string) {
        this.term = value;
    }
}
